module.exports = __webpack_public_path__ + "img/Ad-Banner-Bottom.1f629cc2.jpg";